import React from 'react'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './walking-in-his-clogs.css'

const WalkingInHisClogs = (props) => {
  return (
    <div className="walking-in-his-clogs-container1">
      <Helmet>
        <title>Walk a mile - marjangerrits.nl</title>
        <meta
          name="description"
          content="Albert Gerrits en Albert Woltjes droegen klompen in de Tweede Wereldoorlog."
        />
        <meta property="og:title" content="Walk a mile - marjangerrits.nl" />
        <meta
          property="og:description"
          content="Albert Gerrits en Albert Woltjes droegen klompen in de Tweede Wereldoorlog."
        />
      </Helmet>
      <NavbarInteractive rootClassName="navbar-interactiveroot-class-name17"></NavbarInteractive>
      <div className="walking-in-his-clogs-blogtitel-en-datum">
        <div className="walking-in-his-clogs-container2">
          <h1 className="walking-in-his-clogs-titel BlogTitel">
            Walk a mile in his clogs
          </h1>
        </div>
      </div>
      <div className="walking-in-his-clogs-container3">
        <p className="walking-in-his-clogs-datum">
          <span>30-01-2024</span>
          <br></br>
        </p>
        <img
          alt="image"
          src="/Blog foto's/roze%20klompen-1500h.jpg"
          className="walking-in-his-clogs-foto"
        />
        <span className="walking-in-his-clogs-tekst">
          <span>
            Dat heb ik gedaan, een mijl in hun klompen gelopen. Niet in deze
            mooie zachte exemplaren die nu mijn voeten warm houden. Nee, mijn
            vader en schoonvader moesten in de oorlog slechtpassende houten
            schoenen aan.
          </span>
          <br></br>
          <br></br>
          <span>
            Toen mijn vader in Kamp Amersfoort aankwam, moest hij al zijn kleren
            én zijn schoenen uittrekken en kreeg hij oude soldatenkledij en
            klompen. Wat had hij daar een hekel aan. Bij vertrek naar Duitsland
            kreeg hij zijn kleding en schoenen weer terug, maar toen hij in
            concentratiekamp Buchenwald arriveerde, gebeurde hetzelfde opnieuw.
            Zijn kleding en mooie leren schoenen werden ingewisseld voor
            streepjeskleding en klompen. Nou ja, klompen, het waren houten zolen
            met een stoffen lap die weinig bescherming boden. Hij heeft dan ook
            een voetwond opgelopen in het kamp, maar had het geluk dat een arts
            bereid was voor hem te liegen en hem op te nemen in de ziekenboeg.
          </span>
          <br></br>
          <br></br>
          <span className="Schuingedrukt_tekst">
            Ab hinkelt achter de verpleger aan. Ze gaan de achterste barak in.
            Ab moet zich uitkleden waarna een arts hem onderzoekt. De arts, ook
            een gevangene, is op de hoogte van zijn wond en werkt mee. Hij neemt
            de temperatuur op en zegt: ‘difterie, opname akkoord’.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br className="Schuingedrukt_tekst"></br>
          <span className="Schuingedrukt_tekst">
            De verpleger wijst Ab naar een brits in de laatste rij en vertelt
            dat hier het minst gecontroleerd wordt. De Revierkapo en SS-kamparts
            zijn als de dood voor besmettelijke ziektes en blijven vanzelf uit
            zijn buurt. Mocht het toch een keer gebeuren dat ze naar zijn bed
            komen, moet Ab stil blijven liggen, ogen naar het plafond gericht,
            slap, ziek, koortsig. Hoe minder hij opvalt, hoe beter.
          </span>
          <br></br>
          <br></br>
          <span>
            Ook mijn Duitse schoonvader kreeg klompen gedurende zijn
            gevangenschap. Het probleem was dat hij zulke grote voeten had en
            zijn benen en voeten zo opgezwollen waren door ondervoeding, dat de
            klompen vier maten te klein waren. Daardoor heeft hij lange tijd op
            blote voeten rondgestrompeld. Toen de zwelling afgenomen was, heeft
            hij zijn voeten er toch in weten te proppen en in een later stadium
            heeft hij zelf sandalen gemaakt.
          </span>
          <br></br>
          <br></br>
          <span className="Schuingedrukt_tekst">
            De blaadjes aan de bomen verkleuren en de Seine laten ze links
            liggen. In de zomer heeft hij van een stuk oud leer en stof een
            soort sandalen kunnen maken zodat hij niet in die te kleine klompen
            hoeft te strompelen. Nu het kouder wordt trekt hij zijn sokken aan.
            Het is goed dat hij geen meiden hoeft te versieren, zijn tenen
            steken er dwars doorheen. Hij zal Mutti vragen of ze een keer
            naaigerei kan sturen. Alles liever dan zijn klompen weer aan moeten.
          </span>
          <br></br>
          <br></br>
          <span>
            Ik ben de afgelopen jaren in de schoenen van mijn vader en
            schoonvader gaan staan om een boek over hun oorlogsverleden te
            schrijven. In het begin voorzichtig, want wat zou mijn Duitse
            schoonvader uitgevreten hebben? Het bekende gedicht Judge Softly van
            Mary Lathrap uit 1895 heeft me hier zeker bij geholpen en ik zou
            willen dat de hele wereld de tekst hiervan ter harte nam. Hieronder
            citeer ik de laatste strofe:
          </span>
          <br></br>
          <br></br>
          <span className="Schuingedrukt_tekst">
            Remember to walk a mile in his moccasins
          </span>
          <br className="Schuingedrukt_tekst"></br>
          <span className="Schuingedrukt_tekst">
            and remember the lessons of humanity taught to you by your elders.
          </span>
          <br className="Schuingedrukt_tekst"></br>
          <span className="Schuingedrukt_tekst">
            We will be known forever by the tracks we leave
          </span>
          <br className="Schuingedrukt_tekst"></br>
          <span className="Schuingedrukt_tekst">
            in other people&apos;s lives, our kindnesses and generosity.
          </span>
          <br></br>
          <br></br>
          <span className="Dikgedrukt_tekst">
            Take the time to walk a mile in his moccasins.
          </span>
        </span>
      </div>
      <div className="walking-in-his-clogs-andere-blogs">
        <h2 className="walking-in-his-clogs-lees-ook">
          <span>Lees ook:</span>
          <br></br>
        </h2>
        <div className="walking-in-his-clogs-laatste3-blogposts"></div>
      </div>
      <Footer rootClassName="footerroot-class-name18"></Footer>
    </div>
  )
}

export default WalkingInHisClogs
